import { apiSlice } from './apiSlice';

export const reportsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getReport: builder.query({
            query: ({ id }) => ({
                url: `/raportit/${id}`,
                validateStatus: (response, result) =>
                    response.status === 200 && !result.isError
            }),
            providesTags: (result, error, arg) => [{ type: 'Reports', id: arg.id }],
            keepUnusedDataFor: 0 // Dont cache any reports.
        }),
        addNewReport: builder.mutation({
            query: newReport => ({
                url: '/raportit',
                method: 'POST',
                body: newReport
            }),
            invalidatesTags: (result, error, arg) => {
                const eventId = result?.tapahtumaId || arg?.tapahtumaId || arg?.id;
                const reportId = result?.id;

                return [
                    'Reports',
                    'Events',
                    ...(reportId ? [{ type: 'Reports', id: reportId }] : []),
                    ...(eventId ? [{ type: 'Events', id: eventId }] : [])
                ];
            }
        }),
        getAllReports: builder.query({
            query: () => ({
                url: '/raportit',
            }),
            providesTags: ['Reports']
        }),
        updateReport: builder.mutation({
            query: updatedReport => ({
                url: '/raportit',
                method: 'PUT',
                body: updatedReport
            }),
            invalidatesTags: (result, error, arg) => {
                const eventId = result?.tapahtumaId || arg?.tapahtumaId || arg?.id;
                const reportId = result?.raportti || arg?.raportti || arg?.id;

                return [
                    'Reports',
                    'Events',
                    ...(reportId ? [{ type: 'Reports', id: reportId }] : []),
                    ...(eventId ? [{ type: 'Events', id: eventId }] : [])
                ];
            }
        })
    })
});

export const {
    useGetReportQuery,
    useAddNewReportMutation,
    useUpdateReportMutation,
    useGetAllReportsQuery
} = reportsApiSlice;